import React, { useEffect, useState } from 'react';
import { useAdoption } from '../../context/AdoptionContext';
import '../../styles/Adoption.css';

function Hotspot({ content }) {
  const { dismissContent } = useAdoption();
  const [position, setPosition] = useState(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!content.target_selector) return;

    const measure = () => {
      const el = document.querySelector(content.target_selector);
      if (!el) { setPosition(null); return; }
      const rect = el.getBoundingClientRect();
      setPosition({
        top: rect.top + window.scrollY + rect.height / 2,
        left: rect.left + window.scrollX + rect.width + 12,
      });
    };

    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', measure, true);
    return () => {
      window.removeEventListener('resize', measure);
      window.removeEventListener('scroll', measure, true);
    };
  }, [content.target_selector]);

  if (!position) return null;

  return (
    <>
      <div
        className="adopt-hotspot"
        style={{ top: position.top, left: position.left }}
        onClick={() => setExpanded(!expanded)}
      >
        <span className="adopt-hotspot-dot" />
        <span className="adopt-hotspot-ping" />
      </div>
      {expanded && (
        <div
          className="adopt-hotspot-popover"
          style={{ top: position.top + 16, left: position.left + 16 }}
        >
          {content.title && <div className="adopt-hotspot-title">{content.title}</div>}
          <div className="adopt-hotspot-body">{content.body}</div>
          <button className="adopt-hotspot-dismiss" onClick={() => dismissContent(content.id)}>
            Got it
          </button>
        </div>
      )}
    </>
  );
}

export default Hotspot;
